export const siteConfig = {
  siteName: '秘密教学',
  siteDescription: '隐藏知识体系的深度学习指南',
  siteUrl: 'https://mimijiaoxue.com',
  siteAuthor: '秘密教学团队',
  foundingYear: '2018',
  email: 'contact@mimijiaoxue.com',
  phone: '+86 400-888-9999',
  address: '北京市海淀区中关村南大街5号院创新大厦B座1206室',
}